<template>
  <div>
    <b-table
      :data="data"
      :bordered="isBordered"
      :striped="isStriped"
      :narrowed="isNarrowed"
      :hoverable="isHoverable"
      :focusable="isFocusable"
      :paginated="isPaginated"
      :pagination-simple="isPaginationSimple"
      :mobile-cards="hasMobileCards"
      :backend-pagination="backEndPagination"
      @page-change="onPageChange"
      :per-page="PperPage"
      :total="total"
      :current-page="currentPage"
      :default-sort-direction="defaultSortDirection"
      :checked-rows.sync="checkedRows"
      :checkable="isCheckable"
      :default-sort="defaultSort"
    >
      <template slot-scope="props">
        <slot v-bind="props"></slot>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey">
            <p>
              <b-icon icon="alert-box" size="is-large"></b-icon>
            </p>
            <h2>No data available.</h2>
          </div>
        </section>
      </template>

      <template slot="bottom-left">
        <!-- <b-field grouped group-multiline>
          <b-select v-model="PperPage" :disabled="!isPaginated">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
            <option value="25">25 per page</option>
          </b-select>
        </b-field>-->
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "DataTable",

  props: {
    isBordered: { type: Boolean, default: false },
    isStriped: { type: Boolean, default: false },
    isNarrowed: { type: Boolean, default: false },
    isHoverable: { type: Boolean, default: false },
    isFocusable: { type: Boolean, default: false },
    hasMobileCards: { type: Boolean, default: false },
    isCheckable: { type: Boolean, default: false },
    isPaginationSimple: { type: Boolean, default: false },

    isPaginated: { type: Boolean, default: false },
    backEndPagination: { type: Boolean, default: false },
    defaultSortDirection: { type: String, default: "ASC" },
    defaultSort: { type: Array | String },
    perPage: { type: Number, default: 10 },
    total: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    onPageChange: {
      type: Function,
      default: () => {
        console.log("Empty @onPageChange Function called");
      }
    },
    data: { type: Array, required: true }
  },

  data() {
    return {
      selected: {},
      checkedRows: [],
      PperPage: this.perPage
    };
  }
};
</script>
